<template>
  <v-container class="fill-height" fluid>
    <v-snackbar
      v-model="snackbar.show"
      :top="snackbar.y === 'top'"
      :bottom="snackbar.y === 'bottom'"
      :left="snackbar.x === 'left'"
      :right="snackbar.x === 'right'"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
    >
      {{ snackbar.text }}
    </v-snackbar>

    <LoadingMask :loading="loading" />

    <v-row align="center" justify="center">
      <v-col cols="auto">
        <Signin v-if="authState === 'signin'" @set-auth-state="setAuthState" @loading="loading = $event" />
        <Signup v-if="authState === 'signup'" @set-auth-state="setAuthState" />
        <Reset v-if="authState === 'reset'"  @set-auth-state="setAuthState" ref="reset" />
        <Verify v-if="authState === 'verify'" @set-auth-state="setAuthState" />
        <Activate v-if="authState === 'activate'" @set-auth-state="setAuthState" ref="activate" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import LoadingMask from '@/components/LoadingMask'
import Signin from '@/components/auth/Signin'
import Signup from '@/components/auth/Signup'
import Verify from '@/components/auth/Verify'
import Activate from '@/components/auth/Activate'
import Reset from '@/components/auth/Reset'

@Component({
  components: {
    LoadingMask,
    Signin,
    Signup,
    Verify,
    Activate,
    Reset
  }
})
export default class Auth extends Vue {
  drawer = null
  loading = false
  authState = 'signin'
  email = null
  snackbar = {
    show: false,
    color: null,
    text: null,
    timeout: 6000,
    x: null,
    y: 'top'
  }

  @Action setUser

  setAuthState (data) {
    this.loading = true
    setTimeout(() => {
      this.authState = data.state
      if (data.state === 'reset') {
        this.$nextTick(() => {
          this.$refs.reset.setData(data.email, data.code)
        })
      }
      if (data.state === 'reset' || data.state === 'signin') {
        this.$nextTick(() => {
          if (data.message.length > 0) {
            this.snackbar.color = 'success'
            this.snackbar.text = data.message
            this.snackbar.show = true
          }
        })
      }
      if (data.state === 'activate') {
        this.$nextTick(() => {
          this.$refs.activate.setData(data.email)
        })
      }
      this.loading = false
    }, 250)
  }
}
</script>

<style>
div[min-width-300] {
  min-width: 300px;
}
div[min-width-400] {
  min-width: 400px;
}
</style>
